import React from "react";
const LexWorkplaceLogo = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 512 512"
		>
			<polygon
				className="lexWorkplaceLogo"
				points="172.2 -.1 -.1 -.1 -.1 511.6 511.9 511.6 511.9 339.3 172.2 339.3 172.2 -.1"
			/>
			<rect
				className="lexWorkplaceLogo"
				x="342.5"
				y="-.1"
				width="169.4"
				height="169.4"
			/>
		</svg>
	);
};
export default LexWorkplaceLogo;
